import type { StarRating } from "../../models/types";
import { RATING_LABELS } from "../../models/types";

/** Render star rating display (readonly) */
export function renderStars(rating: StarRating | undefined): string {
  if (!rating) return "";
  const filled = "★".repeat(rating);
  const empty = "☆".repeat(5 - rating);
  return `<span class="book-card__rating" title="${RATING_LABELS[rating]}">${filled}${empty}</span>`;
}

/** Render interactive star rating input */
export function renderStarInput(
  current: StarRating | undefined,
  name: string,
): string {
  let html = `<div class="star-rating" data-name="${name}">`;
  for (let i = 1; i <= 5; i++) {
    const filled = current && i <= current ? " star-rating__star--filled" : "";
    html += `<span class="star-rating__star${filled}" data-value="${i}" title="${RATING_LABELS[i as StarRating]}">★</span>`;
  }
  html += "</div>";
  return html;
}

/** Escape HTML */
export function esc(str: string | undefined | null): string {
  if (!str) return "";
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
